
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 16.732A2 2 0 0112 13a2 2 0 011 3.732V18a1 1 0 11-2 0v-1.268z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 5v4.755A8 8 0 0010 24h4a8 8 0 005-14.245V5a5 5 0 00-5-5h-4a5 5 0 00-5 5zm12 0v3.582A7.977 7.977 0 0014 8h-4c-1.06 0-2.074.207-3 .582V5a3 3 0 013-3h4a3 3 0 013 3zm-7 5h4a6 6 0 010 12h-4a6 6 0 010-12z","fill":"#fff"}})])
          )
        }
      }
    